import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { OpportunityDetailsResponse } from "lib/generated/integration-api";
import { useIntegrationApi } from "lib/integrationApiContext";

type QueryKey = [string, string];

export function useOpportunityCrmDetails(
  guid: string,
  options?: UseQueryOptions<
    OpportunityDetailsResponse,
    unknown,
    OpportunityDetailsResponse,
    QueryKey
  >,
) {
  const api = useIntegrationApi();
  return useQuery(
    ["opportunityCrmDetails", guid],
    async () => {
      const response = await api.opportunityDetails({ opportunityDetailsRequest: { guid: guid } });
      return response;
    },
    options,
  );
}
